module.exports = __webpack_public_path__ + "img/donut-chart-dark-01.a5e67128.jpg";